import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Workspace } from '@/features/iam/workspaces/Workspace'
import { Id } from '@/infra/id'

export type WorkspaceWithInventoryItemsProps =
  ModelProps<WorkspaceWithInventoryItems>

/**
 * A workspace's service item count.
 */
export class WorkspaceWithInventoryItems extends Model<WorkspaceWithInventoryItems> {
  workspaceId = Id.none

  @observable accessor workspace: Workspace = Workspace.none
  @observable accessor total = 0
}
